export default {
    book: 'Varaa {product}',
    age_limit: 'Oltava vähintään {age} vuotias',
    upgrade_product: 'Lisätuotteet',
    choose_product: 'Valitse {product}',
    days: '{count} vrk | {count} vrk',
    login_register: 'Kirjaudu / rekisteröidy',
    keyless_benefits: {
        label: 'Suoraan autoon {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Täysi vakuutus',
            zero_excess: 'Nolla omavastuu',
            phone_as_a_key: 'Puhelin toimii avaimena.',
            straight_to_car: 'Ei odotusta',
            no_queues: 'Ei jonoja',
            online_id_check: 'Henkilöllisyyden tarkastus verkkopalvelussa',
            self_checkout: 'Nouto itsepalveluna',
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/fi/quotes/vehicle_card.js